module.exports = __webpack_public_path__ + "media/components/guide-page/static/icon-hood-ccf7c372bab249a8aa179af55ba3eccc.svg";